import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { WEB_CORE_URL } from "../../configurations/paths.config";

const checkAuth = async () => {
    return await axios({ method: "GET", url: `${WEB_CORE_URL}/check-cookies`, headers: authHeaderJson() });
}


const removeAuth = async () => {
    await axios({ method: "GET", url: `${WEB_CORE_URL}/remove-cookies-api`, headers: authHeaderJson() });
}

export {
    checkAuth,
    removeAuth,
}